import React from 'react';
import { Typography } from '../../components/Typography';

export const PostDate: React.FC = (props) => (
  <Typography component="p" textColor="dark-grey" {...props} />
);
